
import { Card } from "@/components/ui/card";

export const WebhookEvents = () => {
  return (
    <div className="space-y-6">
      <h3 className="font-semibold text-lg">Supported Webhook Events:</h3>
      
      <div className="space-y-4">
        <Card className="p-4">
          <h4 className="font-medium mb-2">message.received</h4>
          <p className="text-sm text-gray-600 mb-2">Triggered when a new SMS is received</p>
          <pre className="bg-gray-100 p-4 rounded-lg text-sm">
{`{
  "event": "message.received",
  "data": {
    "message_id": "msg_123abc",
    "from": "+1234567890",
    "content": "Message content",
    "received_at": "2024-02-08T20:31:00Z"
  }
}`}
          </pre>
        </Card>

        <Card className="p-4">
          <h4 className="font-medium mb-2">message.sent</h4>
          <p className="text-sm text-gray-600 mb-2">Triggered when an SMS is sent successfully</p>
          <pre className="bg-gray-100 p-4 rounded-lg text-sm">
{`{
  "event": "message.sent",
  "data": {
    "message_id": "msg_123abc",
    "to": "+1234567890",
    "status": "sent",
    "sent_at": "2024-02-08T20:31:00Z"
  }
}`}
          </pre>
        </Card>

        <Card className="p-4">
          <h4 className="font-medium mb-2">message.delivered</h4>
          <p className="text-sm text-gray-600 mb-2">Triggered when an SMS is delivered to recipient</p>
          <pre className="bg-gray-100 p-4 rounded-lg text-sm">
{`{
  "event": "message.delivered",
  "data": {
    "message_id": "msg_123abc",
    "to": "+1234567890",
    "status": "delivered",
    "delivered_at": "2024-02-08T20:31:00Z"
  }
}`}
          </pre>
        </Card>

        <Card className="p-4">
          <h4 className="font-medium mb-2">message.failed</h4>
          <p className="text-sm text-gray-600 mb-2">Triggered when SMS sending fails</p>
          <pre className="bg-gray-100 p-4 rounded-lg text-sm">
{`{
  "event": "message.failed",
  "data": {
    "message_id": "msg_123abc",
    "to": "+1234567890",
    "status": "failed",
    "error": "Recipient number not reachable",
    "failed_at": "2024-02-08T20:31:00Z"
  }
}`}
          </pre>
        </Card>

        <Card className="p-4 bg-pink-50">
          <p className="text-sm text-gray-600">
            <strong>Security Note:</strong> All webhook events are signed using your signing key. 
            Verify the signature in the X-Signature header to ensure the authenticity of webhook events.
            The signature is a HMAC SHA-256 hash of the request body using your signing key.
          </p>
        </Card>
      </div>
    </div>
  );
};
